import React from "react"
import styled from "styled-components"
import Left from "./Left"
import Right from "./Right"

export default function Quote() {
  return (
    <Wrapper className="section section-center">
      <Left />
      <Right />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
